var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.417 2.5a.417.417 0 1 0-.834 0v7.084H2.5a.417.417 0 0 0 0 .833h7.083V17.5a.417.417 0 0 0 .834 0v-7.083H17.5a.417.417 0 1 0 0-.833h-7.083V2.5Z",
    fill: "currentColor"
  })));
};

export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40MTY3IDIuNTAwMTZDMTAuNDE2NyAyLjI3MDA0IDEwLjIzMDIgMi4wODM1IDEwIDIuMDgzNUM5Ljc2OTkyIDIuMDgzNSA5LjU4MzM3IDIuMjcwMDQgOS41ODMzNyAyLjUwMDE2VjkuNTgzNUgyLjUwMDA0QzIuMjY5OTIgOS41ODM1IDIuMDgzMzcgOS43NzAwNCAyLjA4MzM3IDEwLjAwMDJDMi4wODMzNyAxMC4yMzAzIDIuMjY5OTIgMTAuNDE2OCAyLjUwMDA0IDEwLjQxNjhIOS41ODMzN1YxNy41MDAyQzkuNTgzMzcgMTcuNzMwMyA5Ljc2OTkyIDE3LjkxNjggMTAgMTcuOTE2OEMxMC4yMzAyIDE3LjkxNjggMTAuNDE2NyAxNy43MzAzIDEwLjQxNjcgMTcuNTAwMlYxMC40MTY4SDE3LjVDMTcuNzMwMiAxMC40MTY4IDE3LjkxNjcgMTAuMjMwMyAxNy45MTY3IDEwLjAwMDJDMTcuOTE2NyA5Ljc3MDA0IDE3LjczMDIgOS41ODM1IDE3LjUgOS41ODM1SDEwLjQxNjdWMi41MDAxNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";